var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6237 3.89827C22.6237 2.28358 21.3148 0.974609 19.7001 0.974609H4.10725C2.49256 0.974609 1.18359 2.28358 1.18359 3.89827V19.4911C1.18359 21.1058 2.49256 22.4148 4.10725 22.4148H19.7001C21.3148 22.4148 22.6237 21.1058 22.6237 19.4911V3.89827ZM20.6746 3.89827C20.6746 3.36004 20.2383 2.92371 19.7001 2.92371H4.10725C3.56903 2.92371 3.1327 3.36004 3.1327 3.89827V19.4911C3.1327 20.0294 3.56903 20.4657 4.10725 20.4657H19.7001C20.2383 20.4657 20.6746 20.0294 20.6746 19.4911V3.89827Z",
    fill: "#0F0F0F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89381 17.0756L9.09945 9.36531C9.46882 8.68813 10.4412 8.68813 10.8106 9.36531L13.8985 15.0266L14.9562 13.1757C15.3303 12.521 16.2743 12.521 16.6484 13.1757L18.8674 17.0588C19.2386 17.7085 18.7694 18.5169 18.0212 18.5169H5.74936C5.00962 18.5169 4.53958 17.725 4.89381 17.0756Z",
    fill: "#EF710A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7537 7.79676C17.7537 8.87322 16.8811 9.74587 15.8046 9.74587C14.7281 9.74587 13.8555 8.87322 13.8555 7.79676C13.8555 6.7203 14.7281 5.84766 15.8046 5.84766C16.8811 5.84766 17.7537 6.7203 17.7537 7.79676Z",
    fill: "#EF710A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropImage);
export default __webpack_public_path__ + "static/media/dropImage.89f74b11bc114929c02979bf4b5f575a.svg";
export { ForwardRef as ReactComponent };